<template lang="pug">
  modal(:title='$t("removeResource.title")' @closeModal='closeModal')
    p.text-normal.content(v-if='text')
      | {{ text }}
    .row.end.m4-top-5
      button.primary-button.m4-right-6(@click='closeModal')
        | {{ $t('removeResource.cancel') }}
      button.secondary-button(@click='deleteResource')
        | {{ $t('removeResource.remove') }}
</template>

<script>
import Modal from '@/components/Modal'
import { mapActions, mapState } from 'vuex'

import { removeResourceFromFolder, removeResourceFromAllFolders } from '@/services/FolderService'

export default {
  components: { Modal },
  props: {
    text: { type: String }
  },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.removeResourceModal.props
    })
  },
  methods: {
    ...mapActions(['hideElement']),
    closeModal() {
      this.hideElement({ element: 'removeResourceModal' })
    },
    hideAndReload() {
      this.hideElement({ element: 'removeResourceModal' })
      this.$emit('reload')
    },
    async deleteResource() {
      const removeResource = this.modalProps.folderId ? removeResourceFromFolder : removeResourceFromAllFolders
      removeResource(this.modalProps.resourceId, this.modalProps.folderId).then(response => this.hideAndReload())
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin: 25px 0;
}
</style>
